import React, { useEffect, useState } from "react";
import HsComparePage from "./HsComparePage";
import CandidateHskCompare from "./CandidateHskCompare";

/**
 * HS 비교 메뉴(2026-10-06) — 기존 '국가별 비교'에 '후보 세번 비교'(같은 한국 물품의 서로 다른 HSK 후보 둘)를 더한다.
 * 검증 화면에서 comparison_id 로 들어오면 후보 세번 비교를 바로 연다. 기존 국가별 비교는 그대로.
 */
export function readComparisonId() {
  try {
    const id = new URLSearchParams(window.location.search).get("comparison_id");
    return id && /^c[0-9a-f]{32}$/.test(id) ? id : null;
  } catch (_) {
    return null;
  }
}

export default function HsCompareHub({ embedded = false }) {
  const [comparisonId, setComparisonId] = useState(readComparisonId);
  const [mode, setMode] = useState(comparisonId ? "candidate" : "country");
  useEffect(() => {
    const onPop = () => {
      if (!/[?&]audit=hs-compare\b/.test(window.location.search)) return;   // 다른 화면의 주소 변화는 무시
      const id = readComparisonId();
      setComparisonId(id);
      if (id) setMode("candidate");
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  const tab = (key, label) => (
    <button type="button" role="tab" aria-selected={mode === key} onClick={() => setMode(key)}
      style={{ padding: "6px 14px", border: 0, borderBottom: mode === key ? "2px solid #1a56db" : "2px solid transparent",
        background: "none", color: mode === key ? "#1a56db" : "#4b5563", fontWeight: mode === key ? 700 : 500, cursor: "pointer", fontSize: 14 }}>
      {label}
    </button>
  );
  return (
    <div data-testid="hs-compare-hub">
      <div role="tablist" style={{ display: "flex", gap: 4, borderBottom: "1px solid #e5e7eb", padding: embedded ? "8px 16px 0" : "0 0 0" }}>
        {tab("country", "국가별 비교")}
        {tab("candidate", "후보 세번 비교")}
      </div>
      <div style={{ display: mode === "country" ? "block" : "none" }}><HsComparePage embedded={embedded} /></div>
      {mode === "candidate" && <div style={{ padding: 16 }}><CandidateHskCompare comparisonId={comparisonId} /></div>}
    </div>
  );
}
